import { AppStore } from './types'

export const initialAppState: AppStore = {
  error: false,
  isLoading: false
}
